import React, { useState } from 'react'
import './styles.scss'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import Toggle from 'react-toggle'
import DataWrapperChart from 'components/DataWrapperChart'

const checkIsMobile = window.innerWidth <= 599

export const HospVaccChart = () => {
  const [isCurrentWave, setCurrentWave] = useState<boolean>(true)

  return (
    <div className='graphic chart' id='hospVaccToggle'>
      <h3>Covid-Spitaleintritte nach Impfstatus pro 100'000 Personen</h3>
      <div className='toggleWrapper'>
        <div className='center'>
          <div className={'label ' + (!isCurrentWave ? '' : 'off')}>20-59</div>
          <div className='toggleContainer'>
            <Toggle
              defaultChecked={isCurrentWave}
              icons={false}
              onChange={() => {
                setCurrentWave(!isCurrentWave)
              }}
            />
          </div>
          <div className={'label right ' + (isCurrentWave ? '' : 'off')}>
            60+
          </div>
        </div>
      </div>

      <div
        className='switchMap'
        style={{ position: 'relative', display: 'block' }}
      >
        <div
          style={{
            opacity: !isCurrentWave ? '0' : '1.0',
            position: 'absolute',
            top: '0',
            zIndex: !isCurrentWave ? 1 : 99,
            width: '100%'
          }}
        >
          <AutofitIFrame
            src='//datawrapper.dwcdn.net/EQ9Ye/'
            style={{ height: checkIsMobile ? '490px' : '460px' }}
          />
          {/* <DataWrapperChart chartId='EQ9Ye' height={504} /> */}
        </div>
        <div
          style={{
            opacity: isCurrentWave ? '0' : '1.0',
            position: 'relative',
            top: '0',
            zIndex: !isCurrentWave ? 99 : 1,
            width: '100%'
          }}
        >
          <AutofitIFrame
            src='//datawrapper.dwcdn.net/TSG3x/'
            style={{ height: checkIsMobile ? '490px' : '460px' }}
          />
          {/* <DataWrapperChart chartId='TSG3x' height={504} /> */}
        </div>
      </div>
    </div>
  )
}
